module.exports = __webpack_public_path__ + "img/b7fd3b540983d4b7d4d806a44b32c54c.png";